import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as d3 from 'd3';
import { ScatterPointDTO } from 'src/app/models/obs/scatterPointDTO';
import { Tier3 } from 'src/app/models/obs/tier3';
import { BridgeService } from 'src/app/services/util/bridge.service';

@Component({
  selector: 'app-adm-scatter',
  templateUrl: './adm-scatter.component.html',
  styleUrl: './adm-scatter.component.scss'
})
export class AdmScatterComponent implements OnInit {


  @Input() private t3: Tier3[];
  @Input() private band: string;
  @Input() private scatterpoint: ScatterPointDTO[];
  @Input() private csv: string;
  @Input() private dx1: number;
  @Input() private dx2: number;
  @Input() private dy1: number;
  @Input() private dy2: number;
  @Input() private year: string;

  @Output() selectedPoint: EventEmitter<any> = new EventEmitter<any>();


  idT3: number = 0;

  constructor(private bridgeServ: BridgeService) { }

  ngOnInit() {
    // Suscripción al Subject de comunicación del observable de IdT3
    this.bridgeServ.enviarIdObservable.subscribe(id => {
      this.idT3 = id;
    });
    if (this.band == 'risk' || this.band == 'opp') {
      this.drawMap(this.scatterpoint);
    }
    this.cambioId(this.idT3);
  }

  drawMap(data: any[]) {

    var self = this;
    const l = 10;
    // Set the dimensions and margins of the graph
    var margin = { top: 10, right: 30, bottom: 30, left: 60 };
    var width = 960 - margin.left - margin.right;
    var height = 700 - margin.top - margin.bottom;

    // Remove previous svg
    d3.select("#svg-scatter").remove();

    // Append the svg object to the body of the page
    var svg = d3.select("#scatter")
      .append("svg")
      .attr("id", "svg-scatter")
      .attr("preserveAspectRatio", "xMinYMin meet")
      .attr("viewBox", "0 0 960 700")
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var prom_x = 0;
    var prom_y = 0;

    // Calculate average probability and impact
    data.forEach((d: any) => {
      prom_x += +d.probabilidad;
      prom_y += +d.impacto;
    });
    prom_x /= data.length;
    prom_y /= data.length;

    // Add X axis
    var x = d3.scaleLinear()
      .domain([this.dx1, this.dx2])
      .range([0, width]);
    svg.append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x));

    // Add Y axis
    var y = d3.scaleLinear()
      .domain([this.dy1, this.dy2])
      .range([height, 0]);
    svg.append("g")
      .call(d3.axisLeft(y));

    svg.append("line")
      .attr("class", "prom_x")
      .attr("x1", x(prom_x))
      .attr("y1", height)
      .attr("x2", x(prom_x))
      .attr("y2", 0)
      .style("stroke", "#B4484F")
      .style("stroke-dasharray", "5,5")
      .style("fill", "none");

    svg.append("line")
      .attr("class", "prom_y")
      .attr("x1", width)
      .attr("y1", y(prom_y))
      .attr("x2", 0)
      .attr("y2", y(prom_y))
      .style("stroke", "#B4484F")
      .style("stroke-dasharray", "5,5")
      .style("fill", "none");

    svg.append("text")
      .text("Probabilidad")
      .attr("fill", "black")
      .style("font-size", 16)
      .style("font-weight", "Bold")
      .attr("x", width / 2)
      .attr("y", height + 30)
      .style("text-anchor", "middle");

    svg.append("text")
      .text("Impacto")
      .attr("fill", "black")
      .style("font-size", 16)
      .style("font-weight", "Bold")
      .style("text-anchor", "middle")
      .attr("transform", "translate (" + -30 + ", " + height / 2 + ") rotate(270)");

    // Add dots
    svg.selectAll(".dot")
      .data(data, (d: any) => d.codigo)
      .enter()
      .append("rect")
      .classed("rect", true)
      .attr("x", (d: any) => +d.mp + x(d.probabilidad))
      .attr("y", (d: any) => +d.mi + y(d.impacto) - l * Math.sqrt(2) / 2)
      .attr("width", l)
      .attr("height", l)
      .style("fill", (d: any) => d.color)
      .on("click", click)
      .call(d3.drag()
        .on("start", dragStartDot)
        .on("drag", dragDot)
        .on("end", dragEndDot)
      );

    // Función de inicio del arrastre de los puntos
    function dragStartDot(event, d) {
      d3.select(this).raise(); // Eleva el punto al frente      
      d.initialX = event.x;
      d.initialY = event.y;
    }

    // Función para arrastrar el punto
    function dragDot(event, d) {
      var currentX = event.x;
      var currentY = event.y;
      var deltaX = currentX - d.initialX;
      var deltaY = currentY - d.initialY;
      var newX = +d3.select(this).attr("x") + deltaX;
      var newY = +d3.select(this).attr("y") + deltaY;

      d3.select(this)
        .attr("x", newX)
        .attr("y", newY);

      d.initialX = currentX;
      d.initialY = currentY;
    }

    // Función al soltar el punto
    function dragEndDot(event, d) {
      var newX = +d3.select(this).attr("x");
      var newY = +d3.select(this).attr("y");
      d.mp = newX - x(d.probabilidad);
      d.mi = newY - y(d.impacto) + l * Math.sqrt(2) / 2;
    }

    svg.selectAll(".text")
      .data(data, (d: any) => d.codigo)
      .enter()
      .append("text")
      .attr("class", "text")
      .attr("id", (d: any) => "text-" + d.codigo)
      .text((d: any) => d.etiqueta)
      .attr("fill", "black")
      .style("font-size", 10)
      .attr("x", (d: any) => {
        let mp = +d.mp + x(d.probabilidad) + +d.mtx;
        return mp;
      })
      .attr("y", (d: any) => {
        let mi = +d.mi + y(d.impacto) + +d.mty;
        return mi;
      })
      .style("text-anchor", "middle")
      .attr("stroke", "white")
      .attr('paint-order', 'stroke')
      .attr('stroke-linejoin', 'round')
      .attr("stroke-width", 2)
      .on('mousedown', dragStart);


    function dragStart(event, d) {      
      var initialX = event.pageX;
      var initialY = event.pageY;
      var element = this;

      d3.select(window)
        .on('mousemove', dragText)
        .on('mouseup', dragEnd);

      function dragText(event) {
        var currentX = event.pageX;
        var currentY = event.pageY;
        var deltaX = currentX - initialX;
        var deltaY = currentY - initialY;
        var newX = parseFloat(d3.select(element).attr("x")) + deltaX;
        var newY = parseFloat(d3.select(element).attr("y")) + deltaY;
        d3.select(element)
          .attr("x", newX)
          .attr("y", newY);
        initialX = currentX;
        initialY = currentY;
      }

      function dragEnd() {
        d3.select(window)
          .on('mousemove', null)
          .on('mouseup', null);
        var dataPoint = data.find(point => "text-" + point.codigo === d3.select(element).attr("id"));
        var newX = parseFloat(d3.select(element).attr("x"));
        var newY = parseFloat(d3.select(element).attr("y"));
        dataPoint.mtx = newX - dataPoint.mp - x(dataPoint.probabilidad);
        dataPoint.mty = newY - dataPoint.mi - y(dataPoint.impacto);
      }
    }

    var t = d3.transition()
      .duration(250)
      .ease(d3.easeLinear);

    function click(event, d) {
      self.selectedPoint.emit(d);

      d3.selectAll(".label")
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .style("fill", "black")
        .style("font-size", "10px")
        .style("font-weight", "normal");

      d3.selectAll("#text-" + d.codigo)
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .style("fill", "#B4484F")
        .style("font-weight", "bold")
        .style('font-size', "12px");
    }
  }
  // Función de envío de mensaje
  cambioId(id: number) {
    this.bridgeServ.enviarIdT3(id);
  }

}
